<template>
    <div v-bind="$attrs" @click="tryOpenModal" class="cursor-pointer">
        <slot></slot>
    </div>
    <ModalCustom
        :is-open="state.isLoadModalOpen"
        @close="tryCloseLoadModal"
        title="Select Videos"
    >
        <div class="w-[80vw] max-h-[50vh] overflow-y-auto">
            <div class="text-sm">
                {{ state.selectedVideos.length }} videos selected
            </div>
            <loading-circle class="m-12" v-if="state.isLoading" />
            <div v-else class="mt-2 p-4 flex gap-4">
                <div
                    class="
                        grid grid-cols-1
                        md:grid-cols-3
                        gap-4
                        lg:grid-cols-4
                        flex-grow flex-shrink
                    "
                >
                    <div
                        v-if="state.videos.length === 0"
                        class="col-span-4 self-center"
                    >
                        <div class="text-center text-gray-500">
                            No videos found
                        </div>
                    </div>
                    <div
                        v-for="video in state.videos"
                        :key="video.id"
                        class="
                            p-4
                            bg-white
                            shadow-xl
                            rounded-lg
                            border-[3px] border-gray-200
                            text-center
                            cursor-pointer
                            hover:border-primary
                        "
                        :class="{
                            'border-primary': state.selectedVideos.find(
                                (v) => v.id === video.id
                            ),
                        }"
                        @click="select(video)"
                    >
                        <div
                            class="
                                relative
                                group
                                text-sm
                                md:text-base
                                fit-content
                                flex flex-col
                                overflow-hidden
                            "
                        >
                            <VideoPlayer
                                :thumbnail="video.thumbnail"
                                :url="video.url"
                            ></VideoPlayer>
                        </div>
                        <div class="block text-md">
                            {{ video.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ModalCustom>
</template>

<script setup>
import { computed, onMounted, reactive } from "vue";
import LoadingCircle from "./LoadingCircle.vue";
import ModalCustom from "./ModalCustom.vue";
import AppButton from "./AppButton.vue";
import VideoPlayer from "./VideoPlayer.vue";

const props = defineProps(["videoApi", "play", "updateVideoTagsApi"]);
const emit = defineEmits(["loaded"]);
const state = reactive({
    videos: [],
    selectedVideos: props.play.videos ?? [],
    play: props.play,
});

const tryCloseLoadModal = () => {
    if (state.isLoading) {
        return;
    }

    state.selectedVideos.value = props.play.videos ?? [];
    state.isLoadModalOpen = false;
};

async function select(selectedVideo) {
    const selected = state.selectedVideos.find(
        (video) => video.id === selectedVideo.id
    );

    if (selected) {
        state.selectedVideos = state.selectedVideos.filter(
            (video) => video.id !== selectedVideo.id
        );
    } else {
        state.selectedVideos = [...state.selectedVideos, selectedVideo];
    }

    await axios.post(props.updateVideoTagsApi, {
        play_id: props.play.play_id,
        tags: state.selectedVideos.map((video) => video.id).join(","),
    });
}

async function tryOpenModal() {
    emit("loaded");
    state.isLoadModalOpen = true;
    state.isLoading = true;
    try {
        await refreshData();
    } catch {}
    state.isLoading = false;
}

async function refreshData() {
    state.videos = (await axios.get(props.videoApi, {})).data;

    let playVideoApi = new URL(props.videoApi);
    playVideoApi.searchParams.append("playId", props.play.play_id);
    state.selectedVideos = (await axios.get(playVideoApi, {})).data;
}

onMounted(() => {});
</script>

<style scoped></style>
